package music.jammers.client.shared.analytics.screen

import music.jammers.client.shared.analytics.FirebaseAnalytics

interface ScreenAnalytics {

    fun onScreenOpen(screenName: String)
}

internal class ScreenAnalyticsImpl(
    private val firebaseAnalytics: FirebaseAnalytics,
) : ScreenAnalytics {

    override fun onScreenOpen(screenName: String) {
        firebaseAnalytics.logEvent(FirebaseAnalytics.Event.SCREEN_VIEW) {
            param(FirebaseAnalytics.Param.SCREEN_NAME, screenName)
        }
    }
}